<template>
  <div>
    <div class="page-title mb-4 underline"><mdb-icon icon="highlighter" /> 사전 필답 평가 <span v-if="mode === 'VIEW'">결과보기</span></div>
    <test-common-process v-if="mode === 'CHECKTEST'" v-model="mode"/>
    <pre-writing-test v-if="mode === 'TEST'"
        :questions="test.questions" :answers="answer.answers" @save-test="onSaveTest"/>
    <pre-writing-test-view v-if="mode === 'VIEW' && answer"
        :questions="test.questions" :answer="answer" />
    <div v-if="mode === -1"> 등록된 문제가 없습니다. </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import PreTest from '@/models/test/PreTest'
import PreTestAnswer from '@/models/test/PreTestAnswer'
import PreWritingTest from '@/components/test/pretest/PreWritingTest.vue';
import PreWritingTestView from '@/components/test/pretest/PreWritingTestView.vue';
import TestCommonProcess from '@/components/test/TestCommonProcess.vue';

export default {
  name: 'StudentPrediagTest',
  components: { TestCommonProcess, PreWritingTest, PreWritingTestView },
  props: [],
  data: () => ({
    mode: -1,
    test: undefined,
    answer: undefined
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('training', ['training'])
  },
  methods: {
    async onSaveTest () {
      if (!confirm('제출할까요?')) return;
      this.answer.mark(this.test)
      await this.answer.save();
      this.mode = 'VIEW'
    },
    async load () {
      // 문제가 있는지 검사
      if (!this.training._id || !this.profile._id) return
      const training = this.training._id
      const student = this.profile._id
      this.test = await PreTest.get({ training })
      if (this.test) { // 문제가 있다면 답지가 있는지 검사
        this.answer = await PreTestAnswer.get({ training, student })
        if (this.answer) { // 답지가 있는 경우
          this.mode = 'VIEW'
        } else { // 답지 없음
          this.answer = await PreTestAnswer.create(training, student, this.test)
          this.mode = 'CHECKTEST'
        }
      } else { // 등록된 문제 없음
        this.mode = -1
      }
    }
  },
  watch: {
    async profile () {
      this.load()
    }
  },
  async created () {
    this.load()
  }
}
</script>
